import { render, staticRenderFns } from "./OnboardingStep02.vue?vue&type=template&id=b3e32402&scoped=true&"
import script from "./OnboardingStep02.vue?vue&type=script&lang=js&"
export * from "./OnboardingStep02.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStep02.vue?vue&type=style&index=0&id=b3e32402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e32402",
  null
  
)

export default component.exports